import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 16px;

  @media only screen and (max-width: 400px) {
    gap: 8px;
  }
`

const Button = styled.button`
  align-items: center;
  background-color: transparent;
  border: 1px solid #EBF3EF;
  border-radius: 50%;
  color: #2D473E;
  cursor: pointer;
  font-family: var(--font-bold);
  display: flex;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: -0.4px;
  justify-content: center;
  min-height: 36px;
  padding: 0;
  text-align: center;
  min-width: 36px;

  &:hover:not(:disabled) {
    background-color: var(--primary);
    color: var(--white);
  }

  @media only screen and (max-width: 400px) {
      font-size: 14px;
      min-height: 28px;
      min-width: 28px;
    }
`

export const ArrowButton = styled(Button)`
  & > img {
    height: 14px;
    width: 14px;
  }

  &:first-child {
    & > img {
      transform: rotate(90deg);
    }
  }

  &:last-child {
    & > img {
      transform: rotate(-90deg);
    }
  }

  &:disabled {
    cursor: not-allowed;
  }

  @media only screen and (max-width: 400px) {
    img {
      height: 10px;
      width: 10px;
    }
  }
`

export const PageButton = styled(Button)`
  &.active {
    background-color: var(--primary);
    color: var(--white);
  }
`
